<template>
  <div class="filters-container">
    <div class="filters">
      <category-filters v-for="category in categories" :key="category.id" :category="category" :value="category.selected" @updateCategory="updateCategory"/>
      <div class='tabs bottom'>
        <p class='bottom'>
          {{ $t('message.presentation') }}
        </p>
      </div>
    </div>
    <div id='geocoder' class='geocoder'></div>
  </div>
</template>

<script>
import _ from 'lodash'
import CategoryFilters from './CategoryFilters'
export default {
  components: {
    CategoryFilters
  },
  data () {
    return {
      categories: _.cloneDeep(this.$store.state.categories),
      categoryType: null
    }
  },
  methods: {
    updateCategory (updatedCategory) {
      const updatedIndex = this.categories.findIndex(category => category.id === updatedCategory.id)
      // cf https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats for use of Object.assign and splice
      const newCategory = Object.assign({}, this.categories[updatedIndex], updatedCategory)
      this.categories.splice(updatedIndex, 1, newCategory)
      this.categoryType = updatedCategory.id === 'commerces-de-vente-au-detail' ? 'commercial' : 'community'
    }
  },
  watch: {
    categories: {
      handler (categories, oldCategories) {
        this.$store.commit('setFilters', categories)
        if (this.categoryType === 'community') global.foodMap.filterViz(this.$store.state.filters)
        if (this.categoryType === 'commercial') global.foodMap.filterCommercialViz(this.$store.state.commercialFilters)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.bottom {
  margin: 10px 10px;
  text-align: justify;
  text-justify: inter-word;
}
.filters-container {
  display:flex;
  height: 95vh;
  overflow-y: auto;
  border-bottom: solid gold;
  .filters {
    flex:1;
    font-size: 14px;
    font-weight: 500;
    &:last-child {
      margin-left: 1em;

    }
  }
}

.commercialDataTab {
  display: none;
}

</style>
